import { Events, NavController, NavParams } from 'ionic-angular'
import { Component } from '@angular/core'
import { ItineraryPage } from '../itinerary/itinerary'
import { Map } from '../stop/map'

@Component({
  templateUrl: 'build/pages/stop/location.html',
  directives: [Map]
})
export class LocationPage {
  private stop: any

  constructor(private nav: NavController, private events: Events, params: NavParams) {
    this.stop = params.get('stop')
  }

  itinerary() {
    this.nav.push(ItineraryPage, {
      stop: this.stop
    })
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.events.publish('carpostal:stop:location', this.stop)
    })
  }
}
